module.exports = __webpack_public_path__ + "img/error.fc888ec7.gif";